module.exports = __webpack_public_path__ + "static/media/bp3.d15c71ca.jpg";